"use strict";

require("core-js/modules/es.object.define-property.js");

require("core-js/modules/es.array.for-each.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.keys.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  Asset: true,
  AssetContent: true,
  BlendModeEnum: true,
  BoundingRectangle: true,
  Code: true,
  Color: true,
  ColorCreateBody: true,
  ColorData: true,
  ColorDesignToken: true,
  ColorDesignTokenMetadata: true,
  ColorStop: true,
  ColorUpdateBody: true,
  CommentCreateBody: true,
  CommentUpdateBody: true,
  Component: true,
  ComponentGroup: true,
  ComponentSection: true,
  ComponentSectionReference: true,
  ComponentSectionVariant: true,
  ComponentSectionVariantProperty: true,
  ComponentUpdateBody: true,
  ComponentVariantProperty: true,
  ComponentVersion: true,
  ComponentVersionSummary: true,
  ConnectedComponent: true,
  ConnectedComponentLink: true,
  DesignTokenFont: true,
  DesignTokenProject: true,
  DesignTokenResource: true,
  DesignTokenSource: true,
  DesignTokenStyleguide: true,
  DesignTokens: true,
  DisabledOrLinkedRemPreferences: true,
  EnabledRemPreferences: true,
  EntityReference: true,
  ErrorResponse: true,
  FlowBoard: true,
  FlowBoardConnection: true,
  FlowBoardConnectionPosition: true,
  FlowBoardConnector: true,
  FlowBoardConnectorLabel: true,
  FlowBoardGroup: true,
  FlowBoardNode: true,
  FlowBoardNodeColor: true,
  FlowBoardPosition: true,
  FlowBoardScreenNode: true,
  FlowBoardShapeNode: true,
  FlowBoardTextNode: true,
  FlowBoardVariantGroupNode: true,
  Gradient: true,
  Grid: true,
  HorizontalGrid: true,
  HotspotBoundingRectangle: true,
  LanguageEnum: true,
  Layer: true,
  LayerBlur: true,
  LayerBorder: true,
  LayerFill: true,
  LayerPosition: true,
  LayerShadow: true,
  LayerTextStyle: true,
  LayerTextStyleRange: true,
  Link: true,
  LinkDestination: true,
  Notification: true,
  NotificationActor: true,
  NotificationResource: true,
  NotificationTypeEnum: true,
  NotificationUpdateBody: true,
  Organization: true,
  OrganizationBilling: true,
  OrganizationMember: true,
  OrganizationMemberInviteBody: true,
  OrganizationMemberUpdateBody: true,
  OrganizationSummary: true,
  OrganizationWebhook: true,
  OrganizationWebhookCreateBody: true,
  OrganizationWebhookEventEnum: true,
  OrganizationWebhookUpdateBody: true,
  PingEvent: true,
  Project: true,
  ProjectColorCreatedEvent: true,
  ProjectColorCreatedEventResource: true,
  ProjectColorDeletedEvent: true,
  ProjectColorDeletedEventResource: true,
  ProjectColorEvent: true,
  ProjectColorEventContext: true,
  ProjectColorUpdatedEvent: true,
  ProjectComponentCreatedEvent: true,
  ProjectComponentCreatedEventResource: true,
  ProjectComponentDeletedEvent: true,
  ProjectComponentDeletedEventContext: true,
  ProjectComponentDeletedEventResource: true,
  ProjectComponentEvent: true,
  ProjectComponentEventContext: true,
  ProjectComponentUpdatedEvent: true,
  ProjectComponentVersionCreatedEvent: true,
  ProjectFlowBoardBuiltEvent: true,
  ProjectFlowBoardBuiltEventResource: true,
  ProjectFlowBoardEvent: true,
  ProjectFlowBoardEventContext: true,
  ProjectMember: true,
  ProjectMemberEvent: true,
  ProjectMemberEventContext: true,
  ProjectMemberInviteBody: true,
  ProjectMemberInvitedEvent: true,
  ProjectMemberInvitedEventResource: true,
  ProjectMemberRemovedEvent: true,
  ProjectMemberRemovedEventResource: true,
  ProjectMemberRoleUpdatedEvent: true,
  ProjectNoteCommentCreatedEvent: true,
  ProjectNoteCommentCreatedEventResource: true,
  ProjectNoteCommentDeletedEvent: true,
  ProjectNoteCommentDeletedEventResource: true,
  ProjectNoteCommentEvent: true,
  ProjectNoteCommentEventContext: true,
  ProjectNoteCommentUpdatedEvent: true,
  ProjectNoteCreatedEvent: true,
  ProjectNoteCreatedEventResource: true,
  ProjectNoteDeletedEvent: true,
  ProjectNoteDeletedEventResource: true,
  ProjectNoteEvent: true,
  ProjectNoteEventContext: true,
  ProjectNoteUpdatedEvent: true,
  ProjectScreenCreatedEvent: true,
  ProjectScreenCreatedEventResource: true,
  ProjectScreenDeletedEvent: true,
  ProjectScreenDeletedEventContext: true,
  ProjectScreenDeletedEventResource: true,
  ProjectScreenEvent: true,
  ProjectScreenEventContext: true,
  ProjectScreenUpdatedEvent: true,
  ProjectScreenVersionCreatedEvent: true,
  ProjectScreenVersionCreatedEventResource: true,
  ProjectScreenVersionDeletedEvent: true,
  ProjectScreenVersionDeletedEventResource: true,
  ProjectScreenVersionEvent: true,
  ProjectScreenVersionEventContext: true,
  ProjectScreenVersionUpdatedEvent: true,
  ProjectSpacingTokenCreatedEvent: true,
  ProjectSpacingTokenCreatedEventResource: true,
  ProjectSpacingTokenDeletedEvent: true,
  ProjectSpacingTokenDeletedEventResource: true,
  ProjectSpacingTokenEvent: true,
  ProjectSpacingTokenEventContext: true,
  ProjectSpacingTokenUpdatedEvent: true,
  ProjectStatusEnum: true,
  ProjectTextStyleCreatedEvent: true,
  ProjectTextStyleCreatedEventResource: true,
  ProjectTextStyleDeletedEvent: true,
  ProjectTextStyleDeletedEventResource: true,
  ProjectTextStyleEvent: true,
  ProjectTextStyleEventContext: true,
  ProjectTextStyleUpdatedEvent: true,
  ProjectUpdateBody: true,
  ProjectWebhook: true,
  ProjectWebhookCreateBody: true,
  ProjectWebhookEventEnum: true,
  ProjectWebhookUpdateBody: true,
  RemPreferences: true,
  ResourceProjectSource: true,
  ResourceSource: true,
  ResourceStyleguideSource: true,
  Screen: true,
  ScreenAnnotation: true,
  ScreenAnnotationColor: true,
  ScreenAnnotationCreateBody: true,
  ScreenAnnotationNoteType: true,
  ScreenAnnotationNoteTypeEnum: true,
  ScreenAnnotationPosition: true,
  ScreenAnnotationUpdateBody: true,
  ScreenNote: true,
  ScreenNoteColor: true,
  ScreenNoteColorNameEnum: true,
  ScreenNoteComment: true,
  ScreenNoteCreateBody: true,
  ScreenNotePosition: true,
  ScreenNoteStatusEnum: true,
  ScreenNoteUpdateBody: true,
  ScreenSection: true,
  ScreenUpdateBody: true,
  ScreenVariant: true,
  ScreenVariantGroup: true,
  ScreenVariantGroupReference: true,
  ScreenVariantGroupValue: true,
  ScreenVersion: true,
  ScreenVersionSummary: true,
  SnapshotImage: true,
  SourceEnum: true,
  SpacingDesignToken: true,
  SpacingDesignTokenMetadata: true,
  SpacingSection: true,
  SpacingToken: true,
  SpacingTokenColor: true,
  SpacingTokenUpdateBody: true,
  Styleguide: true,
  StyleguideColorCreatedEvent: true,
  StyleguideColorDeletedEvent: true,
  StyleguideColorEvent: true,
  StyleguideColorEventContext: true,
  StyleguideColorUpdatedEvent: true,
  StyleguideComponentCreatedEvent: true,
  StyleguideComponentDeletedEvent: true,
  StyleguideComponentDeletedEventContext: true,
  StyleguideComponentEvent: true,
  StyleguideComponentEventContext: true,
  StyleguideComponentUpdatedEvent: true,
  StyleguideComponentVersionCreatedEvent: true,
  StyleguideMember: true,
  StyleguideMemberEvent: true,
  StyleguideMemberEventContext: true,
  StyleguideMemberInviteBody: true,
  StyleguideMemberInvitedEvent: true,
  StyleguideMemberInvitedEventResource: true,
  StyleguideMemberRemovedEvent: true,
  StyleguideMemberRemovedEventResource: true,
  StyleguideMemberRoleUpdatedEvent: true,
  StyleguideSpacingTokenCreatedEvent: true,
  StyleguideSpacingTokenDeletedEvent: true,
  StyleguideSpacingTokenEvent: true,
  StyleguideSpacingTokenEventContext: true,
  StyleguideSpacingTokenUpdatedEvent: true,
  StyleguideStatusEnum: true,
  StyleguideTextStyleCreatedEvent: true,
  StyleguideTextStyleDeletedEvent: true,
  StyleguideTextStyleEvent: true,
  StyleguideTextStyleEventContext: true,
  StyleguideTextStyleUpdatedEvent: true,
  StyleguideUpdateBody: true,
  StyleguideWebhook: true,
  StyleguideWebhookCreateBody: true,
  StyleguideWebhookEventEnum: true,
  StyleguideWebhookUpdateBody: true,
  TextStyle: true,
  TextStyleData: true,
  TextStyleDesignToken: true,
  TextStyleDesignTokenMetadata: true,
  TextStyleDesignTokenValue: true,
  TextStyleUpdateBody: true,
  Thumbnails: true,
  TokenCreateAuthorizationCodeBody: true,
  TokenCreateBody: true,
  TokenCreateRefreshTokenBody: true,
  TokenResponse: true,
  User: true,
  UserWebhook: true,
  UserWebhookCreateBody: true,
  UserWebhookEventEnum: true,
  UserWebhookUpdateBody: true,
  VersionCommit: true,
  VersionCommitColor: true,
  VerticalGrid: true,
  WebhookEvent: true,
  WebhookEventActor: true,
  WebhookHealthEnum: true,
  WebhookStatusEnum: true,
  WorkflowStatus: true,
  WorkflowStatusColor: true,
  WorkspaceNotificationCreatedEvent: true,
  WorkspaceNotificationCreatedEventResource: true,
  WorkspaceNotificationEvent: true,
  WorkspaceNotificationUpdatedEvent: true,
  WorkspaceOrganizationEvent: true,
  WorkspaceOrganizationJoinRequestedEvent: true,
  WorkspaceOrganizationMemberEvent: true,
  WorkspaceOrganizationMemberEventContext: true,
  WorkspaceOrganizationMemberInvitedEvent: true,
  WorkspaceOrganizationMemberInvitedEventResource: true,
  WorkspaceOrganizationMemberRemovedEvent: true,
  WorkspaceOrganizationMemberRemovedEventResource: true,
  WorkspaceOrganizationMemberRoleUpdatedEvent: true,
  WorkspaceOrganizationMemberTagUpdatedEvent: true,
  WorkspaceOrganizationUpdatedEvent: true,
  WorkspaceOrganizationUpdatedEventResource: true,
  WorkspaceProjectActivatedEvent: true,
  WorkspaceProjectArchivedEvent: true,
  WorkspaceProjectCreatedEvent: true,
  WorkspaceProjectCreatedEventResource: true,
  WorkspaceProjectDeletedEvent: true,
  WorkspaceProjectDeletedEventResource: true,
  WorkspaceProjectEvent: true,
  WorkspaceProjectStyleguideLinkedEvent: true,
  WorkspaceProjectStyleguideUnlinkedEvent: true,
  WorkspaceProjectUpdatedEvent: true,
  WorkspaceStyleguideActivatedEvent: true,
  WorkspaceStyleguideArchivedEvent: true,
  WorkspaceStyleguideCreatedEvent: true,
  WorkspaceStyleguideCreatedEventResource: true,
  WorkspaceStyleguideDeletedEvent: true,
  WorkspaceStyleguideDeletedEventResource: true,
  WorkspaceStyleguideEvent: true,
  WorkspaceStyleguideStyleguideLinkedEvent: true,
  WorkspaceStyleguideStyleguideUnlinkedEvent: true,
  WorkspaceStyleguideUpdatedEvent: true,
  ZeplinApplication: true
};
Object.defineProperty(exports, "Asset", {
  enumerable: true,
  get: function get() {
    return _models.Asset;
  }
});
Object.defineProperty(exports, "AssetContent", {
  enumerable: true,
  get: function get() {
    return _models.AssetContent;
  }
});
Object.defineProperty(exports, "BlendModeEnum", {
  enumerable: true,
  get: function get() {
    return _models.BlendModeEnum;
  }
});
Object.defineProperty(exports, "BoundingRectangle", {
  enumerable: true,
  get: function get() {
    return _models.BoundingRectangle;
  }
});
Object.defineProperty(exports, "Code", {
  enumerable: true,
  get: function get() {
    return _models.Code;
  }
});
Object.defineProperty(exports, "Color", {
  enumerable: true,
  get: function get() {
    return _models.Color;
  }
});
Object.defineProperty(exports, "ColorCreateBody", {
  enumerable: true,
  get: function get() {
    return _models.ColorCreateBody;
  }
});
Object.defineProperty(exports, "ColorData", {
  enumerable: true,
  get: function get() {
    return _models.ColorData;
  }
});
Object.defineProperty(exports, "ColorDesignToken", {
  enumerable: true,
  get: function get() {
    return _models.ColorDesignToken;
  }
});
Object.defineProperty(exports, "ColorDesignTokenMetadata", {
  enumerable: true,
  get: function get() {
    return _models.ColorDesignTokenMetadata;
  }
});
Object.defineProperty(exports, "ColorStop", {
  enumerable: true,
  get: function get() {
    return _models.ColorStop;
  }
});
Object.defineProperty(exports, "ColorUpdateBody", {
  enumerable: true,
  get: function get() {
    return _models.ColorUpdateBody;
  }
});
Object.defineProperty(exports, "CommentCreateBody", {
  enumerable: true,
  get: function get() {
    return _models.CommentCreateBody;
  }
});
Object.defineProperty(exports, "CommentUpdateBody", {
  enumerable: true,
  get: function get() {
    return _models.CommentUpdateBody;
  }
});
Object.defineProperty(exports, "Component", {
  enumerable: true,
  get: function get() {
    return _models.Component;
  }
});
Object.defineProperty(exports, "ComponentGroup", {
  enumerable: true,
  get: function get() {
    return _models.ComponentGroup;
  }
});
Object.defineProperty(exports, "ComponentSection", {
  enumerable: true,
  get: function get() {
    return _models.ComponentSection;
  }
});
Object.defineProperty(exports, "ComponentSectionReference", {
  enumerable: true,
  get: function get() {
    return _models.ComponentSectionReference;
  }
});
Object.defineProperty(exports, "ComponentSectionVariant", {
  enumerable: true,
  get: function get() {
    return _models.ComponentSectionVariant;
  }
});
Object.defineProperty(exports, "ComponentSectionVariantProperty", {
  enumerable: true,
  get: function get() {
    return _models.ComponentSectionVariantProperty;
  }
});
Object.defineProperty(exports, "ComponentUpdateBody", {
  enumerable: true,
  get: function get() {
    return _models.ComponentUpdateBody;
  }
});
Object.defineProperty(exports, "ComponentVariantProperty", {
  enumerable: true,
  get: function get() {
    return _models.ComponentVariantProperty;
  }
});
Object.defineProperty(exports, "ComponentVersion", {
  enumerable: true,
  get: function get() {
    return _models.ComponentVersion;
  }
});
Object.defineProperty(exports, "ComponentVersionSummary", {
  enumerable: true,
  get: function get() {
    return _models.ComponentVersionSummary;
  }
});
Object.defineProperty(exports, "ConnectedComponent", {
  enumerable: true,
  get: function get() {
    return _models.ConnectedComponent;
  }
});
Object.defineProperty(exports, "ConnectedComponentLink", {
  enumerable: true,
  get: function get() {
    return _models.ConnectedComponentLink;
  }
});
Object.defineProperty(exports, "DesignTokenFont", {
  enumerable: true,
  get: function get() {
    return _models.DesignTokenFont;
  }
});
Object.defineProperty(exports, "DesignTokenProject", {
  enumerable: true,
  get: function get() {
    return _models.DesignTokenProject;
  }
});
Object.defineProperty(exports, "DesignTokenResource", {
  enumerable: true,
  get: function get() {
    return _models.DesignTokenResource;
  }
});
Object.defineProperty(exports, "DesignTokenSource", {
  enumerable: true,
  get: function get() {
    return _models.DesignTokenSource;
  }
});
Object.defineProperty(exports, "DesignTokenStyleguide", {
  enumerable: true,
  get: function get() {
    return _models.DesignTokenStyleguide;
  }
});
Object.defineProperty(exports, "DesignTokens", {
  enumerable: true,
  get: function get() {
    return _models.DesignTokens;
  }
});
Object.defineProperty(exports, "DisabledOrLinkedRemPreferences", {
  enumerable: true,
  get: function get() {
    return _models.DisabledOrLinkedRemPreferences;
  }
});
Object.defineProperty(exports, "EnabledRemPreferences", {
  enumerable: true,
  get: function get() {
    return _models.EnabledRemPreferences;
  }
});
Object.defineProperty(exports, "EntityReference", {
  enumerable: true,
  get: function get() {
    return _models.EntityReference;
  }
});
Object.defineProperty(exports, "ErrorResponse", {
  enumerable: true,
  get: function get() {
    return _models.ErrorResponse;
  }
});
Object.defineProperty(exports, "FlowBoard", {
  enumerable: true,
  get: function get() {
    return _models.FlowBoard;
  }
});
Object.defineProperty(exports, "FlowBoardConnection", {
  enumerable: true,
  get: function get() {
    return _models.FlowBoardConnection;
  }
});
Object.defineProperty(exports, "FlowBoardConnectionPosition", {
  enumerable: true,
  get: function get() {
    return _models.FlowBoardConnectionPosition;
  }
});
Object.defineProperty(exports, "FlowBoardConnector", {
  enumerable: true,
  get: function get() {
    return _models.FlowBoardConnector;
  }
});
Object.defineProperty(exports, "FlowBoardConnectorLabel", {
  enumerable: true,
  get: function get() {
    return _models.FlowBoardConnectorLabel;
  }
});
Object.defineProperty(exports, "FlowBoardGroup", {
  enumerable: true,
  get: function get() {
    return _models.FlowBoardGroup;
  }
});
Object.defineProperty(exports, "FlowBoardNode", {
  enumerable: true,
  get: function get() {
    return _models.FlowBoardNode;
  }
});
Object.defineProperty(exports, "FlowBoardNodeColor", {
  enumerable: true,
  get: function get() {
    return _models.FlowBoardNodeColor;
  }
});
Object.defineProperty(exports, "FlowBoardPosition", {
  enumerable: true,
  get: function get() {
    return _models.FlowBoardPosition;
  }
});
Object.defineProperty(exports, "FlowBoardScreenNode", {
  enumerable: true,
  get: function get() {
    return _models.FlowBoardScreenNode;
  }
});
Object.defineProperty(exports, "FlowBoardShapeNode", {
  enumerable: true,
  get: function get() {
    return _models.FlowBoardShapeNode;
  }
});
Object.defineProperty(exports, "FlowBoardTextNode", {
  enumerable: true,
  get: function get() {
    return _models.FlowBoardTextNode;
  }
});
Object.defineProperty(exports, "FlowBoardVariantGroupNode", {
  enumerable: true,
  get: function get() {
    return _models.FlowBoardVariantGroupNode;
  }
});
Object.defineProperty(exports, "Gradient", {
  enumerable: true,
  get: function get() {
    return _models.Gradient;
  }
});
Object.defineProperty(exports, "Grid", {
  enumerable: true,
  get: function get() {
    return _models.Grid;
  }
});
Object.defineProperty(exports, "HorizontalGrid", {
  enumerable: true,
  get: function get() {
    return _models.HorizontalGrid;
  }
});
Object.defineProperty(exports, "HotspotBoundingRectangle", {
  enumerable: true,
  get: function get() {
    return _models.HotspotBoundingRectangle;
  }
});
Object.defineProperty(exports, "LanguageEnum", {
  enumerable: true,
  get: function get() {
    return _models.LanguageEnum;
  }
});
Object.defineProperty(exports, "Layer", {
  enumerable: true,
  get: function get() {
    return _models.Layer;
  }
});
Object.defineProperty(exports, "LayerBlur", {
  enumerable: true,
  get: function get() {
    return _models.LayerBlur;
  }
});
Object.defineProperty(exports, "LayerBorder", {
  enumerable: true,
  get: function get() {
    return _models.LayerBorder;
  }
});
Object.defineProperty(exports, "LayerFill", {
  enumerable: true,
  get: function get() {
    return _models.LayerFill;
  }
});
Object.defineProperty(exports, "LayerPosition", {
  enumerable: true,
  get: function get() {
    return _models.LayerPosition;
  }
});
Object.defineProperty(exports, "LayerShadow", {
  enumerable: true,
  get: function get() {
    return _models.LayerShadow;
  }
});
Object.defineProperty(exports, "LayerTextStyle", {
  enumerable: true,
  get: function get() {
    return _models.LayerTextStyle;
  }
});
Object.defineProperty(exports, "LayerTextStyleRange", {
  enumerable: true,
  get: function get() {
    return _models.LayerTextStyleRange;
  }
});
Object.defineProperty(exports, "Link", {
  enumerable: true,
  get: function get() {
    return _models.Link;
  }
});
Object.defineProperty(exports, "LinkDestination", {
  enumerable: true,
  get: function get() {
    return _models.LinkDestination;
  }
});
Object.defineProperty(exports, "Notification", {
  enumerable: true,
  get: function get() {
    return _models.Notification;
  }
});
Object.defineProperty(exports, "NotificationActor", {
  enumerable: true,
  get: function get() {
    return _models.NotificationActor;
  }
});
Object.defineProperty(exports, "NotificationResource", {
  enumerable: true,
  get: function get() {
    return _models.NotificationResource;
  }
});
Object.defineProperty(exports, "NotificationTypeEnum", {
  enumerable: true,
  get: function get() {
    return _models.NotificationTypeEnum;
  }
});
Object.defineProperty(exports, "NotificationUpdateBody", {
  enumerable: true,
  get: function get() {
    return _models.NotificationUpdateBody;
  }
});
Object.defineProperty(exports, "Organization", {
  enumerable: true,
  get: function get() {
    return _models.Organization;
  }
});
Object.defineProperty(exports, "OrganizationBilling", {
  enumerable: true,
  get: function get() {
    return _models.OrganizationBilling;
  }
});
Object.defineProperty(exports, "OrganizationMember", {
  enumerable: true,
  get: function get() {
    return _models.OrganizationMember;
  }
});
Object.defineProperty(exports, "OrganizationMemberInviteBody", {
  enumerable: true,
  get: function get() {
    return _models.OrganizationMemberInviteBody;
  }
});
Object.defineProperty(exports, "OrganizationMemberUpdateBody", {
  enumerable: true,
  get: function get() {
    return _models.OrganizationMemberUpdateBody;
  }
});
Object.defineProperty(exports, "OrganizationSummary", {
  enumerable: true,
  get: function get() {
    return _models.OrganizationSummary;
  }
});
Object.defineProperty(exports, "OrganizationWebhook", {
  enumerable: true,
  get: function get() {
    return _models.OrganizationWebhook;
  }
});
Object.defineProperty(exports, "OrganizationWebhookCreateBody", {
  enumerable: true,
  get: function get() {
    return _models.OrganizationWebhookCreateBody;
  }
});
Object.defineProperty(exports, "OrganizationWebhookEventEnum", {
  enumerable: true,
  get: function get() {
    return _models.OrganizationWebhookEventEnum;
  }
});
Object.defineProperty(exports, "OrganizationWebhookUpdateBody", {
  enumerable: true,
  get: function get() {
    return _models.OrganizationWebhookUpdateBody;
  }
});
Object.defineProperty(exports, "PingEvent", {
  enumerable: true,
  get: function get() {
    return _models.PingEvent;
  }
});
Object.defineProperty(exports, "Project", {
  enumerable: true,
  get: function get() {
    return _models.Project;
  }
});
Object.defineProperty(exports, "ProjectColorCreatedEvent", {
  enumerable: true,
  get: function get() {
    return _models.ProjectColorCreatedEvent;
  }
});
Object.defineProperty(exports, "ProjectColorCreatedEventResource", {
  enumerable: true,
  get: function get() {
    return _models.ProjectColorCreatedEventResource;
  }
});
Object.defineProperty(exports, "ProjectColorDeletedEvent", {
  enumerable: true,
  get: function get() {
    return _models.ProjectColorDeletedEvent;
  }
});
Object.defineProperty(exports, "ProjectColorDeletedEventResource", {
  enumerable: true,
  get: function get() {
    return _models.ProjectColorDeletedEventResource;
  }
});
Object.defineProperty(exports, "ProjectColorEvent", {
  enumerable: true,
  get: function get() {
    return _models.ProjectColorEvent;
  }
});
Object.defineProperty(exports, "ProjectColorEventContext", {
  enumerable: true,
  get: function get() {
    return _models.ProjectColorEventContext;
  }
});
Object.defineProperty(exports, "ProjectColorUpdatedEvent", {
  enumerable: true,
  get: function get() {
    return _models.ProjectColorUpdatedEvent;
  }
});
Object.defineProperty(exports, "ProjectComponentCreatedEvent", {
  enumerable: true,
  get: function get() {
    return _models.ProjectComponentCreatedEvent;
  }
});
Object.defineProperty(exports, "ProjectComponentCreatedEventResource", {
  enumerable: true,
  get: function get() {
    return _models.ProjectComponentCreatedEventResource;
  }
});
Object.defineProperty(exports, "ProjectComponentDeletedEvent", {
  enumerable: true,
  get: function get() {
    return _models.ProjectComponentDeletedEvent;
  }
});
Object.defineProperty(exports, "ProjectComponentDeletedEventContext", {
  enumerable: true,
  get: function get() {
    return _models.ProjectComponentDeletedEventContext;
  }
});
Object.defineProperty(exports, "ProjectComponentDeletedEventResource", {
  enumerable: true,
  get: function get() {
    return _models.ProjectComponentDeletedEventResource;
  }
});
Object.defineProperty(exports, "ProjectComponentEvent", {
  enumerable: true,
  get: function get() {
    return _models.ProjectComponentEvent;
  }
});
Object.defineProperty(exports, "ProjectComponentEventContext", {
  enumerable: true,
  get: function get() {
    return _models.ProjectComponentEventContext;
  }
});
Object.defineProperty(exports, "ProjectComponentUpdatedEvent", {
  enumerable: true,
  get: function get() {
    return _models.ProjectComponentUpdatedEvent;
  }
});
Object.defineProperty(exports, "ProjectComponentVersionCreatedEvent", {
  enumerable: true,
  get: function get() {
    return _models.ProjectComponentVersionCreatedEvent;
  }
});
Object.defineProperty(exports, "ProjectFlowBoardBuiltEvent", {
  enumerable: true,
  get: function get() {
    return _models.ProjectFlowBoardBuiltEvent;
  }
});
Object.defineProperty(exports, "ProjectFlowBoardBuiltEventResource", {
  enumerable: true,
  get: function get() {
    return _models.ProjectFlowBoardBuiltEventResource;
  }
});
Object.defineProperty(exports, "ProjectFlowBoardEvent", {
  enumerable: true,
  get: function get() {
    return _models.ProjectFlowBoardEvent;
  }
});
Object.defineProperty(exports, "ProjectFlowBoardEventContext", {
  enumerable: true,
  get: function get() {
    return _models.ProjectFlowBoardEventContext;
  }
});
Object.defineProperty(exports, "ProjectMember", {
  enumerable: true,
  get: function get() {
    return _models.ProjectMember;
  }
});
Object.defineProperty(exports, "ProjectMemberEvent", {
  enumerable: true,
  get: function get() {
    return _models.ProjectMemberEvent;
  }
});
Object.defineProperty(exports, "ProjectMemberEventContext", {
  enumerable: true,
  get: function get() {
    return _models.ProjectMemberEventContext;
  }
});
Object.defineProperty(exports, "ProjectMemberInviteBody", {
  enumerable: true,
  get: function get() {
    return _models.ProjectMemberInviteBody;
  }
});
Object.defineProperty(exports, "ProjectMemberInvitedEvent", {
  enumerable: true,
  get: function get() {
    return _models.ProjectMemberInvitedEvent;
  }
});
Object.defineProperty(exports, "ProjectMemberInvitedEventResource", {
  enumerable: true,
  get: function get() {
    return _models.ProjectMemberInvitedEventResource;
  }
});
Object.defineProperty(exports, "ProjectMemberRemovedEvent", {
  enumerable: true,
  get: function get() {
    return _models.ProjectMemberRemovedEvent;
  }
});
Object.defineProperty(exports, "ProjectMemberRemovedEventResource", {
  enumerable: true,
  get: function get() {
    return _models.ProjectMemberRemovedEventResource;
  }
});
Object.defineProperty(exports, "ProjectMemberRoleUpdatedEvent", {
  enumerable: true,
  get: function get() {
    return _models.ProjectMemberRoleUpdatedEvent;
  }
});
Object.defineProperty(exports, "ProjectNoteCommentCreatedEvent", {
  enumerable: true,
  get: function get() {
    return _models.ProjectNoteCommentCreatedEvent;
  }
});
Object.defineProperty(exports, "ProjectNoteCommentCreatedEventResource", {
  enumerable: true,
  get: function get() {
    return _models.ProjectNoteCommentCreatedEventResource;
  }
});
Object.defineProperty(exports, "ProjectNoteCommentDeletedEvent", {
  enumerable: true,
  get: function get() {
    return _models.ProjectNoteCommentDeletedEvent;
  }
});
Object.defineProperty(exports, "ProjectNoteCommentDeletedEventResource", {
  enumerable: true,
  get: function get() {
    return _models.ProjectNoteCommentDeletedEventResource;
  }
});
Object.defineProperty(exports, "ProjectNoteCommentEvent", {
  enumerable: true,
  get: function get() {
    return _models.ProjectNoteCommentEvent;
  }
});
Object.defineProperty(exports, "ProjectNoteCommentEventContext", {
  enumerable: true,
  get: function get() {
    return _models.ProjectNoteCommentEventContext;
  }
});
Object.defineProperty(exports, "ProjectNoteCommentUpdatedEvent", {
  enumerable: true,
  get: function get() {
    return _models.ProjectNoteCommentUpdatedEvent;
  }
});
Object.defineProperty(exports, "ProjectNoteCreatedEvent", {
  enumerable: true,
  get: function get() {
    return _models.ProjectNoteCreatedEvent;
  }
});
Object.defineProperty(exports, "ProjectNoteCreatedEventResource", {
  enumerable: true,
  get: function get() {
    return _models.ProjectNoteCreatedEventResource;
  }
});
Object.defineProperty(exports, "ProjectNoteDeletedEvent", {
  enumerable: true,
  get: function get() {
    return _models.ProjectNoteDeletedEvent;
  }
});
Object.defineProperty(exports, "ProjectNoteDeletedEventResource", {
  enumerable: true,
  get: function get() {
    return _models.ProjectNoteDeletedEventResource;
  }
});
Object.defineProperty(exports, "ProjectNoteEvent", {
  enumerable: true,
  get: function get() {
    return _models.ProjectNoteEvent;
  }
});
Object.defineProperty(exports, "ProjectNoteEventContext", {
  enumerable: true,
  get: function get() {
    return _models.ProjectNoteEventContext;
  }
});
Object.defineProperty(exports, "ProjectNoteUpdatedEvent", {
  enumerable: true,
  get: function get() {
    return _models.ProjectNoteUpdatedEvent;
  }
});
Object.defineProperty(exports, "ProjectScreenCreatedEvent", {
  enumerable: true,
  get: function get() {
    return _models.ProjectScreenCreatedEvent;
  }
});
Object.defineProperty(exports, "ProjectScreenCreatedEventResource", {
  enumerable: true,
  get: function get() {
    return _models.ProjectScreenCreatedEventResource;
  }
});
Object.defineProperty(exports, "ProjectScreenDeletedEvent", {
  enumerable: true,
  get: function get() {
    return _models.ProjectScreenDeletedEvent;
  }
});
Object.defineProperty(exports, "ProjectScreenDeletedEventContext", {
  enumerable: true,
  get: function get() {
    return _models.ProjectScreenDeletedEventContext;
  }
});
Object.defineProperty(exports, "ProjectScreenDeletedEventResource", {
  enumerable: true,
  get: function get() {
    return _models.ProjectScreenDeletedEventResource;
  }
});
Object.defineProperty(exports, "ProjectScreenEvent", {
  enumerable: true,
  get: function get() {
    return _models.ProjectScreenEvent;
  }
});
Object.defineProperty(exports, "ProjectScreenEventContext", {
  enumerable: true,
  get: function get() {
    return _models.ProjectScreenEventContext;
  }
});
Object.defineProperty(exports, "ProjectScreenUpdatedEvent", {
  enumerable: true,
  get: function get() {
    return _models.ProjectScreenUpdatedEvent;
  }
});
Object.defineProperty(exports, "ProjectScreenVersionCreatedEvent", {
  enumerable: true,
  get: function get() {
    return _models.ProjectScreenVersionCreatedEvent;
  }
});
Object.defineProperty(exports, "ProjectScreenVersionCreatedEventResource", {
  enumerable: true,
  get: function get() {
    return _models.ProjectScreenVersionCreatedEventResource;
  }
});
Object.defineProperty(exports, "ProjectScreenVersionDeletedEvent", {
  enumerable: true,
  get: function get() {
    return _models.ProjectScreenVersionDeletedEvent;
  }
});
Object.defineProperty(exports, "ProjectScreenVersionDeletedEventResource", {
  enumerable: true,
  get: function get() {
    return _models.ProjectScreenVersionDeletedEventResource;
  }
});
Object.defineProperty(exports, "ProjectScreenVersionEvent", {
  enumerable: true,
  get: function get() {
    return _models.ProjectScreenVersionEvent;
  }
});
Object.defineProperty(exports, "ProjectScreenVersionEventContext", {
  enumerable: true,
  get: function get() {
    return _models.ProjectScreenVersionEventContext;
  }
});
Object.defineProperty(exports, "ProjectScreenVersionUpdatedEvent", {
  enumerable: true,
  get: function get() {
    return _models.ProjectScreenVersionUpdatedEvent;
  }
});
Object.defineProperty(exports, "ProjectSpacingTokenCreatedEvent", {
  enumerable: true,
  get: function get() {
    return _models.ProjectSpacingTokenCreatedEvent;
  }
});
Object.defineProperty(exports, "ProjectSpacingTokenCreatedEventResource", {
  enumerable: true,
  get: function get() {
    return _models.ProjectSpacingTokenCreatedEventResource;
  }
});
Object.defineProperty(exports, "ProjectSpacingTokenDeletedEvent", {
  enumerable: true,
  get: function get() {
    return _models.ProjectSpacingTokenDeletedEvent;
  }
});
Object.defineProperty(exports, "ProjectSpacingTokenDeletedEventResource", {
  enumerable: true,
  get: function get() {
    return _models.ProjectSpacingTokenDeletedEventResource;
  }
});
Object.defineProperty(exports, "ProjectSpacingTokenEvent", {
  enumerable: true,
  get: function get() {
    return _models.ProjectSpacingTokenEvent;
  }
});
Object.defineProperty(exports, "ProjectSpacingTokenEventContext", {
  enumerable: true,
  get: function get() {
    return _models.ProjectSpacingTokenEventContext;
  }
});
Object.defineProperty(exports, "ProjectSpacingTokenUpdatedEvent", {
  enumerable: true,
  get: function get() {
    return _models.ProjectSpacingTokenUpdatedEvent;
  }
});
Object.defineProperty(exports, "ProjectStatusEnum", {
  enumerable: true,
  get: function get() {
    return _models.ProjectStatusEnum;
  }
});
Object.defineProperty(exports, "ProjectTextStyleCreatedEvent", {
  enumerable: true,
  get: function get() {
    return _models.ProjectTextStyleCreatedEvent;
  }
});
Object.defineProperty(exports, "ProjectTextStyleCreatedEventResource", {
  enumerable: true,
  get: function get() {
    return _models.ProjectTextStyleCreatedEventResource;
  }
});
Object.defineProperty(exports, "ProjectTextStyleDeletedEvent", {
  enumerable: true,
  get: function get() {
    return _models.ProjectTextStyleDeletedEvent;
  }
});
Object.defineProperty(exports, "ProjectTextStyleDeletedEventResource", {
  enumerable: true,
  get: function get() {
    return _models.ProjectTextStyleDeletedEventResource;
  }
});
Object.defineProperty(exports, "ProjectTextStyleEvent", {
  enumerable: true,
  get: function get() {
    return _models.ProjectTextStyleEvent;
  }
});
Object.defineProperty(exports, "ProjectTextStyleEventContext", {
  enumerable: true,
  get: function get() {
    return _models.ProjectTextStyleEventContext;
  }
});
Object.defineProperty(exports, "ProjectTextStyleUpdatedEvent", {
  enumerable: true,
  get: function get() {
    return _models.ProjectTextStyleUpdatedEvent;
  }
});
Object.defineProperty(exports, "ProjectUpdateBody", {
  enumerable: true,
  get: function get() {
    return _models.ProjectUpdateBody;
  }
});
Object.defineProperty(exports, "ProjectWebhook", {
  enumerable: true,
  get: function get() {
    return _models.ProjectWebhook;
  }
});
Object.defineProperty(exports, "ProjectWebhookCreateBody", {
  enumerable: true,
  get: function get() {
    return _models.ProjectWebhookCreateBody;
  }
});
Object.defineProperty(exports, "ProjectWebhookEventEnum", {
  enumerable: true,
  get: function get() {
    return _models.ProjectWebhookEventEnum;
  }
});
Object.defineProperty(exports, "ProjectWebhookUpdateBody", {
  enumerable: true,
  get: function get() {
    return _models.ProjectWebhookUpdateBody;
  }
});
Object.defineProperty(exports, "RemPreferences", {
  enumerable: true,
  get: function get() {
    return _models.RemPreferences;
  }
});
Object.defineProperty(exports, "ResourceProjectSource", {
  enumerable: true,
  get: function get() {
    return _models.ResourceProjectSource;
  }
});
Object.defineProperty(exports, "ResourceSource", {
  enumerable: true,
  get: function get() {
    return _models.ResourceSource;
  }
});
Object.defineProperty(exports, "ResourceStyleguideSource", {
  enumerable: true,
  get: function get() {
    return _models.ResourceStyleguideSource;
  }
});
Object.defineProperty(exports, "Screen", {
  enumerable: true,
  get: function get() {
    return _models.Screen;
  }
});
Object.defineProperty(exports, "ScreenAnnotation", {
  enumerable: true,
  get: function get() {
    return _models.ScreenAnnotation;
  }
});
Object.defineProperty(exports, "ScreenAnnotationColor", {
  enumerable: true,
  get: function get() {
    return _models.ScreenAnnotationColor;
  }
});
Object.defineProperty(exports, "ScreenAnnotationCreateBody", {
  enumerable: true,
  get: function get() {
    return _models.ScreenAnnotationCreateBody;
  }
});
Object.defineProperty(exports, "ScreenAnnotationNoteType", {
  enumerable: true,
  get: function get() {
    return _models.ScreenAnnotationNoteType;
  }
});
Object.defineProperty(exports, "ScreenAnnotationNoteTypeEnum", {
  enumerable: true,
  get: function get() {
    return _models.ScreenAnnotationNoteTypeEnum;
  }
});
Object.defineProperty(exports, "ScreenAnnotationPosition", {
  enumerable: true,
  get: function get() {
    return _models.ScreenAnnotationPosition;
  }
});
Object.defineProperty(exports, "ScreenAnnotationUpdateBody", {
  enumerable: true,
  get: function get() {
    return _models.ScreenAnnotationUpdateBody;
  }
});
Object.defineProperty(exports, "ScreenNote", {
  enumerable: true,
  get: function get() {
    return _models.ScreenNote;
  }
});
Object.defineProperty(exports, "ScreenNoteColor", {
  enumerable: true,
  get: function get() {
    return _models.ScreenNoteColor;
  }
});
Object.defineProperty(exports, "ScreenNoteColorNameEnum", {
  enumerable: true,
  get: function get() {
    return _models.ScreenNoteColorNameEnum;
  }
});
Object.defineProperty(exports, "ScreenNoteComment", {
  enumerable: true,
  get: function get() {
    return _models.ScreenNoteComment;
  }
});
Object.defineProperty(exports, "ScreenNoteCreateBody", {
  enumerable: true,
  get: function get() {
    return _models.ScreenNoteCreateBody;
  }
});
Object.defineProperty(exports, "ScreenNotePosition", {
  enumerable: true,
  get: function get() {
    return _models.ScreenNotePosition;
  }
});
Object.defineProperty(exports, "ScreenNoteStatusEnum", {
  enumerable: true,
  get: function get() {
    return _models.ScreenNoteStatusEnum;
  }
});
Object.defineProperty(exports, "ScreenNoteUpdateBody", {
  enumerable: true,
  get: function get() {
    return _models.ScreenNoteUpdateBody;
  }
});
Object.defineProperty(exports, "ScreenSection", {
  enumerable: true,
  get: function get() {
    return _models.ScreenSection;
  }
});
Object.defineProperty(exports, "ScreenUpdateBody", {
  enumerable: true,
  get: function get() {
    return _models.ScreenUpdateBody;
  }
});
Object.defineProperty(exports, "ScreenVariant", {
  enumerable: true,
  get: function get() {
    return _models.ScreenVariant;
  }
});
Object.defineProperty(exports, "ScreenVariantGroup", {
  enumerable: true,
  get: function get() {
    return _models.ScreenVariantGroup;
  }
});
Object.defineProperty(exports, "ScreenVariantGroupReference", {
  enumerable: true,
  get: function get() {
    return _models.ScreenVariantGroupReference;
  }
});
Object.defineProperty(exports, "ScreenVariantGroupValue", {
  enumerable: true,
  get: function get() {
    return _models.ScreenVariantGroupValue;
  }
});
Object.defineProperty(exports, "ScreenVersion", {
  enumerable: true,
  get: function get() {
    return _models.ScreenVersion;
  }
});
Object.defineProperty(exports, "ScreenVersionSummary", {
  enumerable: true,
  get: function get() {
    return _models.ScreenVersionSummary;
  }
});
Object.defineProperty(exports, "SnapshotImage", {
  enumerable: true,
  get: function get() {
    return _models.SnapshotImage;
  }
});
Object.defineProperty(exports, "SourceEnum", {
  enumerable: true,
  get: function get() {
    return _models.SourceEnum;
  }
});
Object.defineProperty(exports, "SpacingDesignToken", {
  enumerable: true,
  get: function get() {
    return _models.SpacingDesignToken;
  }
});
Object.defineProperty(exports, "SpacingDesignTokenMetadata", {
  enumerable: true,
  get: function get() {
    return _models.SpacingDesignTokenMetadata;
  }
});
Object.defineProperty(exports, "SpacingSection", {
  enumerable: true,
  get: function get() {
    return _models.SpacingSection;
  }
});
Object.defineProperty(exports, "SpacingToken", {
  enumerable: true,
  get: function get() {
    return _models.SpacingToken;
  }
});
Object.defineProperty(exports, "SpacingTokenColor", {
  enumerable: true,
  get: function get() {
    return _models.SpacingTokenColor;
  }
});
Object.defineProperty(exports, "SpacingTokenUpdateBody", {
  enumerable: true,
  get: function get() {
    return _models.SpacingTokenUpdateBody;
  }
});
Object.defineProperty(exports, "Styleguide", {
  enumerable: true,
  get: function get() {
    return _models.Styleguide;
  }
});
Object.defineProperty(exports, "StyleguideColorCreatedEvent", {
  enumerable: true,
  get: function get() {
    return _models.StyleguideColorCreatedEvent;
  }
});
Object.defineProperty(exports, "StyleguideColorDeletedEvent", {
  enumerable: true,
  get: function get() {
    return _models.StyleguideColorDeletedEvent;
  }
});
Object.defineProperty(exports, "StyleguideColorEvent", {
  enumerable: true,
  get: function get() {
    return _models.StyleguideColorEvent;
  }
});
Object.defineProperty(exports, "StyleguideColorEventContext", {
  enumerable: true,
  get: function get() {
    return _models.StyleguideColorEventContext;
  }
});
Object.defineProperty(exports, "StyleguideColorUpdatedEvent", {
  enumerable: true,
  get: function get() {
    return _models.StyleguideColorUpdatedEvent;
  }
});
Object.defineProperty(exports, "StyleguideComponentCreatedEvent", {
  enumerable: true,
  get: function get() {
    return _models.StyleguideComponentCreatedEvent;
  }
});
Object.defineProperty(exports, "StyleguideComponentDeletedEvent", {
  enumerable: true,
  get: function get() {
    return _models.StyleguideComponentDeletedEvent;
  }
});
Object.defineProperty(exports, "StyleguideComponentDeletedEventContext", {
  enumerable: true,
  get: function get() {
    return _models.StyleguideComponentDeletedEventContext;
  }
});
Object.defineProperty(exports, "StyleguideComponentEvent", {
  enumerable: true,
  get: function get() {
    return _models.StyleguideComponentEvent;
  }
});
Object.defineProperty(exports, "StyleguideComponentEventContext", {
  enumerable: true,
  get: function get() {
    return _models.StyleguideComponentEventContext;
  }
});
Object.defineProperty(exports, "StyleguideComponentUpdatedEvent", {
  enumerable: true,
  get: function get() {
    return _models.StyleguideComponentUpdatedEvent;
  }
});
Object.defineProperty(exports, "StyleguideComponentVersionCreatedEvent", {
  enumerable: true,
  get: function get() {
    return _models.StyleguideComponentVersionCreatedEvent;
  }
});
Object.defineProperty(exports, "StyleguideMember", {
  enumerable: true,
  get: function get() {
    return _models.StyleguideMember;
  }
});
Object.defineProperty(exports, "StyleguideMemberEvent", {
  enumerable: true,
  get: function get() {
    return _models.StyleguideMemberEvent;
  }
});
Object.defineProperty(exports, "StyleguideMemberEventContext", {
  enumerable: true,
  get: function get() {
    return _models.StyleguideMemberEventContext;
  }
});
Object.defineProperty(exports, "StyleguideMemberInviteBody", {
  enumerable: true,
  get: function get() {
    return _models.StyleguideMemberInviteBody;
  }
});
Object.defineProperty(exports, "StyleguideMemberInvitedEvent", {
  enumerable: true,
  get: function get() {
    return _models.StyleguideMemberInvitedEvent;
  }
});
Object.defineProperty(exports, "StyleguideMemberInvitedEventResource", {
  enumerable: true,
  get: function get() {
    return _models.StyleguideMemberInvitedEventResource;
  }
});
Object.defineProperty(exports, "StyleguideMemberRemovedEvent", {
  enumerable: true,
  get: function get() {
    return _models.StyleguideMemberRemovedEvent;
  }
});
Object.defineProperty(exports, "StyleguideMemberRemovedEventResource", {
  enumerable: true,
  get: function get() {
    return _models.StyleguideMemberRemovedEventResource;
  }
});
Object.defineProperty(exports, "StyleguideMemberRoleUpdatedEvent", {
  enumerable: true,
  get: function get() {
    return _models.StyleguideMemberRoleUpdatedEvent;
  }
});
Object.defineProperty(exports, "StyleguideSpacingTokenCreatedEvent", {
  enumerable: true,
  get: function get() {
    return _models.StyleguideSpacingTokenCreatedEvent;
  }
});
Object.defineProperty(exports, "StyleguideSpacingTokenDeletedEvent", {
  enumerable: true,
  get: function get() {
    return _models.StyleguideSpacingTokenDeletedEvent;
  }
});
Object.defineProperty(exports, "StyleguideSpacingTokenEvent", {
  enumerable: true,
  get: function get() {
    return _models.StyleguideSpacingTokenEvent;
  }
});
Object.defineProperty(exports, "StyleguideSpacingTokenEventContext", {
  enumerable: true,
  get: function get() {
    return _models.StyleguideSpacingTokenEventContext;
  }
});
Object.defineProperty(exports, "StyleguideSpacingTokenUpdatedEvent", {
  enumerable: true,
  get: function get() {
    return _models.StyleguideSpacingTokenUpdatedEvent;
  }
});
Object.defineProperty(exports, "StyleguideStatusEnum", {
  enumerable: true,
  get: function get() {
    return _models.StyleguideStatusEnum;
  }
});
Object.defineProperty(exports, "StyleguideTextStyleCreatedEvent", {
  enumerable: true,
  get: function get() {
    return _models.StyleguideTextStyleCreatedEvent;
  }
});
Object.defineProperty(exports, "StyleguideTextStyleDeletedEvent", {
  enumerable: true,
  get: function get() {
    return _models.StyleguideTextStyleDeletedEvent;
  }
});
Object.defineProperty(exports, "StyleguideTextStyleEvent", {
  enumerable: true,
  get: function get() {
    return _models.StyleguideTextStyleEvent;
  }
});
Object.defineProperty(exports, "StyleguideTextStyleEventContext", {
  enumerable: true,
  get: function get() {
    return _models.StyleguideTextStyleEventContext;
  }
});
Object.defineProperty(exports, "StyleguideTextStyleUpdatedEvent", {
  enumerable: true,
  get: function get() {
    return _models.StyleguideTextStyleUpdatedEvent;
  }
});
Object.defineProperty(exports, "StyleguideUpdateBody", {
  enumerable: true,
  get: function get() {
    return _models.StyleguideUpdateBody;
  }
});
Object.defineProperty(exports, "StyleguideWebhook", {
  enumerable: true,
  get: function get() {
    return _models.StyleguideWebhook;
  }
});
Object.defineProperty(exports, "StyleguideWebhookCreateBody", {
  enumerable: true,
  get: function get() {
    return _models.StyleguideWebhookCreateBody;
  }
});
Object.defineProperty(exports, "StyleguideWebhookEventEnum", {
  enumerable: true,
  get: function get() {
    return _models.StyleguideWebhookEventEnum;
  }
});
Object.defineProperty(exports, "StyleguideWebhookUpdateBody", {
  enumerable: true,
  get: function get() {
    return _models.StyleguideWebhookUpdateBody;
  }
});
Object.defineProperty(exports, "TextStyle", {
  enumerable: true,
  get: function get() {
    return _models.TextStyle;
  }
});
Object.defineProperty(exports, "TextStyleData", {
  enumerable: true,
  get: function get() {
    return _models.TextStyleData;
  }
});
Object.defineProperty(exports, "TextStyleDesignToken", {
  enumerable: true,
  get: function get() {
    return _models.TextStyleDesignToken;
  }
});
Object.defineProperty(exports, "TextStyleDesignTokenMetadata", {
  enumerable: true,
  get: function get() {
    return _models.TextStyleDesignTokenMetadata;
  }
});
Object.defineProperty(exports, "TextStyleDesignTokenValue", {
  enumerable: true,
  get: function get() {
    return _models.TextStyleDesignTokenValue;
  }
});
Object.defineProperty(exports, "TextStyleUpdateBody", {
  enumerable: true,
  get: function get() {
    return _models.TextStyleUpdateBody;
  }
});
Object.defineProperty(exports, "Thumbnails", {
  enumerable: true,
  get: function get() {
    return _models.Thumbnails;
  }
});
Object.defineProperty(exports, "TokenCreateAuthorizationCodeBody", {
  enumerable: true,
  get: function get() {
    return _models.TokenCreateAuthorizationCodeBody;
  }
});
Object.defineProperty(exports, "TokenCreateBody", {
  enumerable: true,
  get: function get() {
    return _models.TokenCreateBody;
  }
});
Object.defineProperty(exports, "TokenCreateRefreshTokenBody", {
  enumerable: true,
  get: function get() {
    return _models.TokenCreateRefreshTokenBody;
  }
});
Object.defineProperty(exports, "TokenResponse", {
  enumerable: true,
  get: function get() {
    return _models.TokenResponse;
  }
});
Object.defineProperty(exports, "User", {
  enumerable: true,
  get: function get() {
    return _models.User;
  }
});
Object.defineProperty(exports, "UserWebhook", {
  enumerable: true,
  get: function get() {
    return _models.UserWebhook;
  }
});
Object.defineProperty(exports, "UserWebhookCreateBody", {
  enumerable: true,
  get: function get() {
    return _models.UserWebhookCreateBody;
  }
});
Object.defineProperty(exports, "UserWebhookEventEnum", {
  enumerable: true,
  get: function get() {
    return _models.UserWebhookEventEnum;
  }
});
Object.defineProperty(exports, "UserWebhookUpdateBody", {
  enumerable: true,
  get: function get() {
    return _models.UserWebhookUpdateBody;
  }
});
Object.defineProperty(exports, "VersionCommit", {
  enumerable: true,
  get: function get() {
    return _models.VersionCommit;
  }
});
Object.defineProperty(exports, "VersionCommitColor", {
  enumerable: true,
  get: function get() {
    return _models.VersionCommitColor;
  }
});
Object.defineProperty(exports, "VerticalGrid", {
  enumerable: true,
  get: function get() {
    return _models.VerticalGrid;
  }
});
Object.defineProperty(exports, "WebhookEvent", {
  enumerable: true,
  get: function get() {
    return _models.WebhookEvent;
  }
});
Object.defineProperty(exports, "WebhookEventActor", {
  enumerable: true,
  get: function get() {
    return _models.WebhookEventActor;
  }
});
Object.defineProperty(exports, "WebhookHealthEnum", {
  enumerable: true,
  get: function get() {
    return _models.WebhookHealthEnum;
  }
});
Object.defineProperty(exports, "WebhookStatusEnum", {
  enumerable: true,
  get: function get() {
    return _models.WebhookStatusEnum;
  }
});
Object.defineProperty(exports, "WorkflowStatus", {
  enumerable: true,
  get: function get() {
    return _models.WorkflowStatus;
  }
});
Object.defineProperty(exports, "WorkflowStatusColor", {
  enumerable: true,
  get: function get() {
    return _models.WorkflowStatusColor;
  }
});
Object.defineProperty(exports, "WorkspaceNotificationCreatedEvent", {
  enumerable: true,
  get: function get() {
    return _models.WorkspaceNotificationCreatedEvent;
  }
});
Object.defineProperty(exports, "WorkspaceNotificationCreatedEventResource", {
  enumerable: true,
  get: function get() {
    return _models.WorkspaceNotificationCreatedEventResource;
  }
});
Object.defineProperty(exports, "WorkspaceNotificationEvent", {
  enumerable: true,
  get: function get() {
    return _models.WorkspaceNotificationEvent;
  }
});
Object.defineProperty(exports, "WorkspaceNotificationUpdatedEvent", {
  enumerable: true,
  get: function get() {
    return _models.WorkspaceNotificationUpdatedEvent;
  }
});
Object.defineProperty(exports, "WorkspaceOrganizationEvent", {
  enumerable: true,
  get: function get() {
    return _models.WorkspaceOrganizationEvent;
  }
});
Object.defineProperty(exports, "WorkspaceOrganizationJoinRequestedEvent", {
  enumerable: true,
  get: function get() {
    return _models.WorkspaceOrganizationJoinRequestedEvent;
  }
});
Object.defineProperty(exports, "WorkspaceOrganizationMemberEvent", {
  enumerable: true,
  get: function get() {
    return _models.WorkspaceOrganizationMemberEvent;
  }
});
Object.defineProperty(exports, "WorkspaceOrganizationMemberEventContext", {
  enumerable: true,
  get: function get() {
    return _models.WorkspaceOrganizationMemberEventContext;
  }
});
Object.defineProperty(exports, "WorkspaceOrganizationMemberInvitedEvent", {
  enumerable: true,
  get: function get() {
    return _models.WorkspaceOrganizationMemberInvitedEvent;
  }
});
Object.defineProperty(exports, "WorkspaceOrganizationMemberInvitedEventResource", {
  enumerable: true,
  get: function get() {
    return _models.WorkspaceOrganizationMemberInvitedEventResource;
  }
});
Object.defineProperty(exports, "WorkspaceOrganizationMemberRemovedEvent", {
  enumerable: true,
  get: function get() {
    return _models.WorkspaceOrganizationMemberRemovedEvent;
  }
});
Object.defineProperty(exports, "WorkspaceOrganizationMemberRemovedEventResource", {
  enumerable: true,
  get: function get() {
    return _models.WorkspaceOrganizationMemberRemovedEventResource;
  }
});
Object.defineProperty(exports, "WorkspaceOrganizationMemberRoleUpdatedEvent", {
  enumerable: true,
  get: function get() {
    return _models.WorkspaceOrganizationMemberRoleUpdatedEvent;
  }
});
Object.defineProperty(exports, "WorkspaceOrganizationMemberTagUpdatedEvent", {
  enumerable: true,
  get: function get() {
    return _models.WorkspaceOrganizationMemberTagUpdatedEvent;
  }
});
Object.defineProperty(exports, "WorkspaceOrganizationUpdatedEvent", {
  enumerable: true,
  get: function get() {
    return _models.WorkspaceOrganizationUpdatedEvent;
  }
});
Object.defineProperty(exports, "WorkspaceOrganizationUpdatedEventResource", {
  enumerable: true,
  get: function get() {
    return _models.WorkspaceOrganizationUpdatedEventResource;
  }
});
Object.defineProperty(exports, "WorkspaceProjectActivatedEvent", {
  enumerable: true,
  get: function get() {
    return _models.WorkspaceProjectActivatedEvent;
  }
});
Object.defineProperty(exports, "WorkspaceProjectArchivedEvent", {
  enumerable: true,
  get: function get() {
    return _models.WorkspaceProjectArchivedEvent;
  }
});
Object.defineProperty(exports, "WorkspaceProjectCreatedEvent", {
  enumerable: true,
  get: function get() {
    return _models.WorkspaceProjectCreatedEvent;
  }
});
Object.defineProperty(exports, "WorkspaceProjectCreatedEventResource", {
  enumerable: true,
  get: function get() {
    return _models.WorkspaceProjectCreatedEventResource;
  }
});
Object.defineProperty(exports, "WorkspaceProjectDeletedEvent", {
  enumerable: true,
  get: function get() {
    return _models.WorkspaceProjectDeletedEvent;
  }
});
Object.defineProperty(exports, "WorkspaceProjectDeletedEventResource", {
  enumerable: true,
  get: function get() {
    return _models.WorkspaceProjectDeletedEventResource;
  }
});
Object.defineProperty(exports, "WorkspaceProjectEvent", {
  enumerable: true,
  get: function get() {
    return _models.WorkspaceProjectEvent;
  }
});
Object.defineProperty(exports, "WorkspaceProjectStyleguideLinkedEvent", {
  enumerable: true,
  get: function get() {
    return _models.WorkspaceProjectStyleguideLinkedEvent;
  }
});
Object.defineProperty(exports, "WorkspaceProjectStyleguideUnlinkedEvent", {
  enumerable: true,
  get: function get() {
    return _models.WorkspaceProjectStyleguideUnlinkedEvent;
  }
});
Object.defineProperty(exports, "WorkspaceProjectUpdatedEvent", {
  enumerable: true,
  get: function get() {
    return _models.WorkspaceProjectUpdatedEvent;
  }
});
Object.defineProperty(exports, "WorkspaceStyleguideActivatedEvent", {
  enumerable: true,
  get: function get() {
    return _models.WorkspaceStyleguideActivatedEvent;
  }
});
Object.defineProperty(exports, "WorkspaceStyleguideArchivedEvent", {
  enumerable: true,
  get: function get() {
    return _models.WorkspaceStyleguideArchivedEvent;
  }
});
Object.defineProperty(exports, "WorkspaceStyleguideCreatedEvent", {
  enumerable: true,
  get: function get() {
    return _models.WorkspaceStyleguideCreatedEvent;
  }
});
Object.defineProperty(exports, "WorkspaceStyleguideCreatedEventResource", {
  enumerable: true,
  get: function get() {
    return _models.WorkspaceStyleguideCreatedEventResource;
  }
});
Object.defineProperty(exports, "WorkspaceStyleguideDeletedEvent", {
  enumerable: true,
  get: function get() {
    return _models.WorkspaceStyleguideDeletedEvent;
  }
});
Object.defineProperty(exports, "WorkspaceStyleguideDeletedEventResource", {
  enumerable: true,
  get: function get() {
    return _models.WorkspaceStyleguideDeletedEventResource;
  }
});
Object.defineProperty(exports, "WorkspaceStyleguideEvent", {
  enumerable: true,
  get: function get() {
    return _models.WorkspaceStyleguideEvent;
  }
});
Object.defineProperty(exports, "WorkspaceStyleguideStyleguideLinkedEvent", {
  enumerable: true,
  get: function get() {
    return _models.WorkspaceStyleguideStyleguideLinkedEvent;
  }
});
Object.defineProperty(exports, "WorkspaceStyleguideStyleguideUnlinkedEvent", {
  enumerable: true,
  get: function get() {
    return _models.WorkspaceStyleguideStyleguideUnlinkedEvent;
  }
});
Object.defineProperty(exports, "WorkspaceStyleguideUpdatedEvent", {
  enumerable: true,
  get: function get() {
    return _models.WorkspaceStyleguideUpdatedEvent;
  }
});
Object.defineProperty(exports, "ZeplinApplication", {
  enumerable: true,
  get: function get() {
    return _models.ZeplinApplication;
  }
});

var _models = require("./models");

var _api = require("./api");

Object.keys(_api).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _api[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _api[key];
    }
  });
});

var _configuration = require("./configuration");

Object.keys(_configuration).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _configuration[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _configuration[key];
    }
  });
});